<template>
  <b-form-group
    :label="label"
    invalid-feedback="* required">
    <b-form-select
      v-model="config[configKey]"
      :options="options" />
  </b-form-group>
</template>

<script>
export default {
  name: "PaywallDropdown",
  props: {
    config: {
      type: Object,
      required: true,
    },
    configKey: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      selected: "",
      options: [
        { value: "", text: "Select Package Type", disabled: false },
        { value: "free", text:"Free", disabled: false },
        { value: "all", text: "All", disabled: false },
        { value: "single", text: "Single", disabled: false },
        { value: "monthly", text: "Monthly", disabled: false },
        { value: "audio", text: "Audio", disabled: false },
        { value: "atbatYearly", text: "At Bat Yearly", disabled: false },
        { value: "atbatMonthly", text: "At Bat Monthly", disabled: false },
      ],
    }
  },
}
</script>

<style scoped>
</style>
